import wixData from 'wix-data';
import wixWindow from 'wix-window';
import wixLocation from 'wix-location';
import {previousPageURL, previousPageName, compareCreatorTypes} from 'public/pages/masterPage.js'
import {fixPriceText} from 'public/books.js'

var index = 0;
var books_more_data_fields = {};
var more_infos_db_with_includes = null;
var books_more_data_multi_referenced_linked_fields_names = []
var books_more_data_referenced_linked_fields_names = []
var books_more_data_all_linked_fields_names = []
var fadeInOption = {"duration": 500, "delay": 0};

async function loadMoreInfoFields(){
	books_more_data_fields["subtitle"] = "כותרת משנה";
	books_more_data_fields["original_book_name"] = "שם הספר במקור";

	await wixData.query("creator_types").find().then(creators_types => {
		more_infos_db_with_includes = wixData.query("7dblos9dbveihebleebikmu");
		creators_types.items.sort(compareCreatorTypes)
		creators_types.items.forEach(creator_type => {
			if(creator_type.multi_shows){
				books_more_data_multi_referenced_linked_fields_names.push(creator_type.field_name);
			} else {
				books_more_data_referenced_linked_fields_names.push(creator_type.field_name);
			}
			books_more_data_all_linked_fields_names.push(creator_type.field_name);
			books_more_data_fields[creator_type.field_name] = creator_type.more_info_field_name;
			if(creator_type.field_name === "translator"){
				books_more_data_fields["original_language"] = "שפת מקור";
			}
		})
	})

	books_more_data_referenced_linked_fields_names.push("main_creator")
	more_infos_db_with_includes.included = books_more_data_referenced_linked_fields_names;
	
	books_more_data_fields["format"] = "פורמט";
	books_more_data_fields["binding"] = "כריכה";
	books_more_data_fields["number_of_pages"] = "מספר עמודים";
	books_more_data_fields["year_of_publication"] = "שנת הוצאה";
	books_more_data_fields["danacode"] = "דאנאקוד";
}

var pre_read_content = ""

wixLocation.onChange((location) => {
  	hideBookDataFields();
	updateMoreInfoCards();
} );

$w.onReady(function () {	
	loadMoreInfoFields().then(() =>{
		updateMoreInfoCards()
	});

	$w("#moreDataCardRepeater").onItemReady(($item, itemData, index) => {
		if(itemData.with_link){
			if(itemData.link !== undefined){
				var text_whit_link_html = '<a href="' + itemData.link + '"><p style="color: #00aef0;" dir="rtl">' + itemData.value + '</p></a>'
				$item("#moreInfoValue").html = text_whit_link_html;
				$item("#moreInfoPropertyName").text = itemData.property;
			}
		}
		else{
			$item("#moreInfoValue").text = itemData.value;
			$item("#moreInfoPropertyName").text = itemData.property;
		}
	});
});

async function include_multi_referenced_results(book_more_info, product_id){
	var tmp_more_info_db = wixData.query("7dblos9dbveihebleebikmu").eq("book", product_id);
	for(const books_more_data_multi_creators_linked_fields_name of books_more_data_multi_referenced_linked_fields_names){
		await tmp_more_info_db.include(books_more_data_multi_creators_linked_fields_name).find().then((more_info_results) => {
			var multi_referenced_feild = more_info_results.items[0][books_more_data_multi_creators_linked_fields_name];
			if (multi_referenced_feild !== undefined && multi_referenced_feild.length > 0) {
				book_more_info[books_more_data_multi_creators_linked_fields_name] = multi_referenced_feild;
				reloadMoreInfoCardsWithParsedData(book_more_info);
			}
		})
	}

	return book_more_info;
}

function reloadMoreInfoCardsWithParsedData(book_more_infos) {
	initMoreInfoCard()
	var rows = [];
	for(var field_name in books_more_data_fields){
		var field_value = book_more_infos[field_name];
		if(field_value !== undefined && field_value !== ""){
			if(books_more_data_all_linked_fields_names.includes(field_name)){
				if (Array.isArray(field_value)){
					field_value.forEach((creatorsLinkFiled, i) => {
						var more_then_one_name = (i === 0 ? books_more_data_fields[field_name] : " " );
						rows.push({
							"_id": String(index++),
							"property": more_then_one_name,
							"value": creatorsLinkFiled["title"],
							"link": creatorsLinkFiled["link-creators-title"],
							"with_link" : true
						})
					})
				} else {
					rows.push({
						"_id": String(index++),
						"property": books_more_data_fields[field_name],
						"value": field_value["title"],
						"link": field_value["link-creators-title"],
						"with_link" : true
					})
					if (field_name === "author" && field_value["english_name"] !== undefined){
						rows.push({
							"_id": String(index++),
							"property": "",
							"value": field_value["english_name"],
							"link": field_value["link-creators-title"],
							"with_link" : true
						})
					}
				}
			}
			else {
				rows.push({
					"_id": String(index++),
					"property": books_more_data_fields[field_name],
					"value": typeof field_value === 'string'? field_value: String(field_value),
					"with_link" : false
				})
			}
		}
	}

	$w("#moreDataCardRepeater").data = rows;
	$w("#moreDataCarBox").show("fade", fadeInOption);
}

function updateMoreInfoCards(){
	initThePeage();	
	$w('#productPage').getProduct().then((product) => {
		var bookCovers = []
		for(var i in product.mediaItems){
			var media = product.mediaItems[i];
			bookCovers.push({
				type: "Image",
				description: "",
				alt: "",
				title: "",
				src: media["src"]
			})
		}

		$w("#bookCoverGallery").items = bookCovers;
		// Mode_info dataSet
    	more_infos_db_with_includes.eq("book", product._id).find().then((more_info_results) => {
			if(more_info_results.length >= 1) {
				var product_more_info = more_info_results.items[0];
				if (product_more_info.main_creator !== undefined){
					$w("#mainCreatorBtn").label = product_more_info.main_creator.title;
					$w("#mainCreatorBtn").link = product_more_info.main_creator["link-creators-title"];
					$w("#mainCreatorBtn").show("fade", fadeInOption)
				} else {
					$w("#mainCreatorBtn").hide();
				}

				var finalPreviousPageName = "דף ראשון";
				if (previousPageName !== undefined && previousPageName !== "" && previousPageName !== null) {
					finalPreviousPageName = previousPageName;
				}
				$w("#nevPre").label = finalPreviousPageName + " > " + product.name;
				$w("#nevPre").link = previousPageURL;

				try {
					// for mobile case
					$w("#bookName").text = product.name;
					$w("#bookName").show("fade", fadeInOption)
					$w("#price").text = fixPriceText(product.formattedPrice);
					$w("#price").show("fade", fadeInOption)
					$w("#discountPrice").text = "";

					if(parseInt(product.discount.value) > 0){
						$w("#discountLine").show()
						$w("#discountPrice").text = fixPriceText(product.formattedDiscountedPrice);
						$w("#discountPrice").show("fade", fadeInOption)
					} else {
						$w("#price").text = "";
						$w("#discountPrice").text = fixPriceText(product.formattedPrice);
					}
					
					$w("#bookSubtitle").text = product_more_info["subtitle"];
					$w("#bookSubtitle").show("fade", fadeInOption)

				} catch {}
				pre_read_content = product_more_info["pre_read_content"];


				reloadMoreInfoCardsWithParsedData(product_more_info)
				include_multi_referenced_results(product_more_info, product._id)
			} 
			else {
				console.error("Can't find more_info, there is no link from 'more_info' to the book")
			}
  		});
  	}).catch((error) => {
    	console.error(error);
  	});
}

function initMoreInfoCard(){
	$w("#moreDataCardRepeater").data = []
}

function hideBookDataFields() {
	if(wixWindow.formFactor !== "Mobile"){
		$w("#productPage").hide("fade", {"duration": 200, "delay": 0});
		$w("#bookCoverGallery").hide("fade", {"duration": 200, "delay": 0});
		$w("#preViewBookButton").hide("fade", {"duration": 200, "delay": 0});
		setTimeout(function() {
			$w("#productPage").show("fade", fadeInOption)
			$w("#bookCoverGallery").show("fade", fadeInOption)
			$w("#preViewBookButton").show("fade", fadeInOption)
		}, 1000);

		$w("#mainCreatorBtn").hide("fade", fadeInOption);
		$w("#bookName").hide("fade", fadeInOption);
		$w("#price").hide("fade", fadeInOption);
		$w("#discountPrice").hide("fade", fadeInOption);
		$w("#bookSubtitle").hide("fade", fadeInOption);
	}
}

function initThePeage(){
	try{
		pre_read_content = ""
		$w("#mainCreatorBtn").label = "";
		$w("#bookName").text = "";
		$w("#price").text = "";
		$w("#discountPrice").text = "";		
		$w("#bookSubtitle").text = "";

		$w("#discountLine").hide()
		$w("#moreDataCarBox").hide();
	} catch {}
	initMoreInfoCard();
}

export function preViewBookButton_click(event) {
	if(pre_read_content === "" || pre_read_content === undefined){
		var original_label = $w("#preViewBookButton").label;
		$w("#preViewBookButton").label = "תצוגה אינה זמינה";
		setTimeout(function() {
			$w("#preViewBookButton").label = original_label;
		}, 2500);
	}
	else {
		wixWindow.openLightbox("popup_read_book", {data: pre_read_content});
	}
}